import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ConsentProvider } from './components/ConsentManager';
import Layout from './components/Layout';
import Home from './pages/Home';
import Tienda from './pages/Tienda';
import ProductDetail from './pages/ProductDetail';
import CartPage from './pages/CartPage';
import Checkout from './pages/Checkout';
import Confirmation from './pages/Confirmation';
import CityPage from './pages/CityPage';
import LegalPage from './pages/LegalPage';
import Admision from './pages/Admision';
import MiArea from './pages/MiArea';
import MiAreaActivar from './pages/MiAreaActivar';
import MaintenanceGate from './components/MaintenanceGate';
import Admin from './pages/admin/Admin';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <ConsentProvider>
          <MaintenanceGate>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tienda" element={<Tienda />} />
              <Route path="/producto/:slug" element={<ProductDetail />} />
              <Route path="/carrito" element={<CartPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/confirmacion/:orderId" element={<Confirmation />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="/admision" element={<Admision />} />
              <Route path="/mi-area" element={<MiArea />} />
              <Route path="/mi-area/activar" element={<MiAreaActivar />} />
              <Route path="/:citySlug" element={<CityPage />} />
            </Route>
            <Route path="/admin/*" element={<Admin />} />
          </Routes>
          </MaintenanceGate>
          </ConsentProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}

export default App;
